import { render, staticRenderFns } from "./account-number-add.vue?vue&type=template&id=574a74c4"
import script from "./account-number-add.vue?vue&type=script&lang=ts"
export * from "./account-number-add.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports